import { isAction } from "@reduxjs/toolkit";

import { saveConfigToServerThunk } from "@/store/thunks";

import { AppDispatch, AppMiddleware } from "../types";

export const configTrackingMiddleware: AppMiddleware = (() => {
    let timeoutId: NodeJS.Timeout | null = null;
    const DEBOUNCE_MS = 2000;

    return (store) => (next) => (action) => {
        const result = next(action);

        if (!isAction(action)) {
            return result;
        }

        if (action.type.startsWith("config/")) {
            if (timeoutId) clearTimeout(timeoutId);

            timeoutId = setTimeout(() => {
                (store.dispatch as AppDispatch)(saveConfigToServerThunk());
                timeoutId = null;
            }, DEBOUNCE_MS);
        }

        return result;
    };
})();
